import { SimpleGrid, Card, Text, Button, Group } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { standardReports } from '../config/standardReports';

export const ReportsGrid = () => {
  const navigate = useNavigate();

  return (
    <SimpleGrid cols={2} spacing="md">
      {standardReports.map((report) => (
        <Card key={report.id} shadow="sm" padding="lg" radius="md" withBorder>
          <Group justify="space-between" mb="xs">
            <Text fw={500}>{report.name}</Text>
          </Group>
          <Text size="sm" c="dimmed" mb="md">
            {report.description}
          </Text>
          <Button 
            variant="light" 
            fullWidth 
            onClick={() => navigate(report.path)}
          >
            View Report
          </Button>
        </Card>
      ))}
    </SimpleGrid>
  );
};